import { auth } from "../../firebase/firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';


function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth); // Firebase sign-out method
      navigate("/", { replace: true });
    } catch (err) {
    }
  };

  return (

    <>
    {/* <button > */}
      <LogoutIcon  onClick={handleLogout} />
    {/* </button> */}
    </>
  );
}


export default LogoutButton;
